import Banner from "common/Banner/Banner";
import Title from "common/Typography/Title";
import Text from "common/Typography/Text";
import cornixWhiteLogo from "images/svg_white_logo.svg";
import cornixLogo from "images/svg_logo.svg";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import { StylableButton } from "common/Buttons/Button";
import { isIOS } from "react-device-detect";
import Flex from "common/Boxes/Flex";
import React, { useState } from "react";
import { localStorageService } from "utils/localStorageService";
import { typography } from "@shared/common/Themes/typography";
import useMedia from "utils/hooks/useMedia";
import {
  APPSTORE_DOWNLOAD_LINK,
  GOOGLE_PLAY_DOWNLOAD_LINK,
  VERY_SMALL_MOBILE,
} from "common/constants";
import styled from "styled-components";
import { isTablet } from "react-device-detect";

const MobileAppBanner = () => {
  const isDarkMode = useSelector(selectIsDarkMode);
  const isSmallMobile = useMedia(
    [`(max-width: ${VERY_SMALL_MOBILE})`],
    [true],
    false
  );

  const [hideBanner, setHideBanner] = useState(
    localStorageService.getParsedValue<number>(MOBILE_APP_BANNER_KEY) || false
  );

  const onCloseClick = () => {
    localStorageService.setValue(MOBILE_APP_BANNER_KEY, 1);
    setHideBanner(1);
  };

  const banner = (
    <StyledBanner $isSmallMobile={isSmallMobile} onCloseClick={onCloseClick}>
      <Flex>
        <Flex>
          <Logo
            src={isDarkMode ? cornixWhiteLogo : cornixLogo}
            $isSmallMobile={isSmallMobile}
          />
          <TitleWrapper $isSmallMobile={isSmallMobile}>
            <Title level={isSmallMobile ? 4 : 3}>Cornix Crypto Trading</Title>
            <Text type="secondary" $size={typography.fontSizes.S}>
              {`FREE - On ${isIOS ? "the App Store" : "Google Play"}`}
            </Text>
          </TitleWrapper>
        </Flex>
        <StyledButton
          $isTablet={isTablet}
          size={isSmallMobile ? "middle" : "large"}
          onClick={() =>
            window.open(
              isIOS ? APPSTORE_DOWNLOAD_LINK : GOOGLE_PLAY_DOWNLOAD_LINK,
              "_blank"
            )
          }
        >
          Open
        </StyledButton>
      </Flex>
    </StyledBanner>
  );

  return hideBanner ? null : banner;
};

export default MobileAppBanner;

const MOBILE_APP_BANNER_KEY = "mobile_app_banner";

const StyledBanner = styled(Banner)<{ $isSmallMobile: boolean }>`
  background: ${(p) => p.theme.colors.layoutBgColor};
  border-bottom: ${(p) => p.theme.borders.hard};
  padding: ${(p) =>
    p.$isSmallMobile ? "12px 32px 12px 12px" : "12px 32px 12px 16px"};
`;
const TitleWrapper = styled.div<{ $isSmallMobile: boolean }>`
  text-align: start;
  margin-left: ${(p) => (p.$isSmallMobile ? 8 : 16)}px;
`;
const Logo = styled.img<{ $isSmallMobile: boolean }>`
  max-height: ${(p) => (p.$isSmallMobile ? 36 : 48)}px;
`;
const StyledButton = styled(StylableButton).attrs({ type: "primary" })<{
  $isTablet: boolean;
}>`
  margin-right: ${(p) => (p.$isTablet ? 8 : 0)}px;
`;
